import { appLogConstants } from '../constants';
import { appLogService } from '../../services';

export const appLogActions = {
  appLogsList,
  appLogLevels,
  appLogShow,
  clearAppLog,
};

function appLogsList(filters) {
  return dispatch => {
    dispatch(request());
    return appLogService.appLogsList(filters)
      .then(
        response => {
          const body = response.data.body || {};
          const meta = body.data || {};
          dispatch(success(body.logs || [], meta.total || 0));
        },
        error => {
          dispatch(failure(error));
        }
      );
  };

  function request() { return { type: appLogConstants.GETALL_REQUEST }; }
  function success(items, total) { return { type: appLogConstants.GETALL_SUCCESS, items, total }; }
  function failure(error) { return { type: appLogConstants.GETALL_FAILURE, error }; }
}

function appLogLevels() {
  return dispatch => {
    return appLogService.appLogLevels()
      .then(
        response => {
          const levels = (response.data.body && response.data.body.levels) || [];
          dispatch(success(levels));
        },
        () => {}
      );
  };

  function success(levels) { return { type: appLogConstants.LEVELS_SUCCESS, levels }; }
}

function appLogShow(id) {
  return dispatch => {
    dispatch(request());
    return appLogService.appLogShow(id)
      .then(
        response => {
          dispatch(success(response.data.body || null));
        },
        error => {
          dispatch(failure(error));
        }
      );
  };

  function request() { return { type: appLogConstants.SHOW_REQUEST }; }
  function success(detail) { return { type: appLogConstants.SHOW_SUCCESS, detail }; }
  function failure(error) { return { type: appLogConstants.SHOW_FAILURE, error }; }
}

function clearAppLog() {
  return { type: appLogConstants.SHOW_CLEAR };
}
